/**
 * Close the software keyboard when a search is submitted from a phone.
 *
 * On Android — Chrome and the Instagram/Telegram WebViews alike — the
 * keyboard's «search» key submits the form but leaves the keyboard up, and on
 * a 660px viewport that keyboard hides the results the submit just produced
 * (tester, 2026-09-22, Android 16). The keyboard follows focus, so dropping
 * focus from the field is the whole fix.
 *
 * Coarse pointers only: on a desktop the field keeps focus so a second query
 * can be typed straight away, which is what a keyboard-and-mouse user expects.
 */
export function blurSearchOnSubmit(form: EventTarget | null): void {
  if (typeof window === 'undefined' || !(form instanceof HTMLElement)) return;
  if (!window.matchMedia?.('(pointer: coarse)').matches) return;
  const field = form.querySelector<HTMLElement>('input, textarea');
  if (field && field === document.activeElement) field.blur();
}
